import * as React from "react";
import Grid from "@mui/material/Grid";
import MailIcon from "@mui/icons-material/Mail";
import {
  Alert,
  Autocomplete,
  Badge,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  TextField,
  Tooltip,
  TextareaAutosize,
  autocompleteClasses,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import WarningIcon from "@mui/icons-material/Warning";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { AppraisalValueTable } from "./AppraisalValues";
import { AppraisalAssetsList } from "./AppraisalAssetList";
import {
  AppraisalReviewServiceURL,
  DocumentServiceURL,
  InvestmentServiceURL,
  LookupServieURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState } from "react";
import { ViewTabList } from "../documents/ViewTabList";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import selectedInvestmentForAppraisalslice, {
  InvestmentNames,
  updateSelectedInvestmentForAppraisal,
} from "../../../redux/slices/selectedInvestmentForAppraisalslice";
import {
  UserContext,
  updateUserContext,
} from "../../../redux/slices/userContextSlice";
import axios, { AxiosResponse } from "axios";
import { wait } from "@testing-library/user-event/dist/utils";
import {
  AllCountriesModel,
  ApplicationUser,
  AppraisalAssetsModel,
  AppraisalsDetailsModelForEquity,
  DocumentTypesModel,
  ExternalAppraisersModel,
  InvestmentIDsModel,
  InvestmentForAppraisalModel,
  UserRoleMapModel,
  AppraisalDetailsModelForCM,
  AppraisalAttachment,
  UploadPreSignedPayloadModel,
  AppraisalDetailsModelForDLorDA,
  AppraisalModel,
  Appraisal,
  AuditLog,
  GetAppraisalModel,
  AppraisalTask,
  AppraisalRevokedRequest,
} from "../../../all_Interfaces";
import { AlertDialog } from "../../util/Dialog";
import { addAuditLogs } from "../../../redux/slices/AuditSlice";
import AppraisalDetailsForUSAppraisal, {
  updateAppraisalDetailsForUSAppraisal,
} from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import { AppraisalValuesForCM } from "./AppraisalValuesForCM";
import { AppraisalValueTableForDLorDA } from "./AppraisalValuesDLorDA";
import { updateAppraisalDetailsForCM } from "../../../redux/slices/AppraisalDetailsForCMSlice";
import { updateAppraisalDetailsForDLorDA } from "../../../redux/slices/AppraisalDetailsForDLorDASlice";
import { DebtAssetsAssetList } from "./DebtAssetsAssetList";
import { ToastMessage } from "../../util/ToastMessage";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { useNavigate, useParams } from "react-router-dom";
import UpdateExistingAttachmentSlice, {
  updateAttachments,
} from "../../../redux/slices/UpdateExistingAttachmentSlice";
import { updateappraisalSubmitEvent } from "../../../redux/slices/AppraisalSubmitEventSlice";
import { LiveTv } from "@mui/icons-material";
import { updateFlagToDisableControlesForAppraisal } from "../../../redux/slices/DisableAppraisalControlsSlice";
import { HamburgerMenu } from "./HamburgerMenu";
import { ApproveRejectComponent } from "../../util/ApproveRejectComponent";
import { HorizontalStepper } from "../../util/Steper";
import AuditButton from "../Audit/auditButton";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const TextareaAutosizee = styled(TextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? grey[900] : grey[50]
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);
const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const DebtLiabilityAppraisalFormView = (props: any) => {
  const params = useParams();
  const page = "view";
  const appraisalId = params.appraisalId;
  const pathnames = window.location.pathname.split("/").filter((x) => x);
  const [openModel, setOpenModel] = useState<{
    isOpen: boolean;
    message: string;
  }>({ isOpen: false, message: "" });
  console.log(window.location.pathname);
  const [assetManagerInvalid, setAssetManagerInvalid] = useState<{
    flag: boolean;
    message: string;
  }>({ flag: false, message: "" });
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [workflowSteps, setWorkflowSteps] = useState<string[]>([]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [appraisalDataAfterSave, setAppraisalDataAfterSave] = useState<{
    appraisalId: string;
    xmin: number;
  }>({ appraisalId: "", xmin: 0 });
  const [openRevokeDialog, setOpenRevokeDialog] = useState<boolean>(false);

  const [documentTypes, setDocumentTypes] = useState<DocumentTypesModel[]>([]);
  const [isSaveClicked, setIsSaveClicked] = useState<boolean>(false);
  const [appraisalType, setAppraisalType] = useState<string>("");

  const [selectedExternalAppraiser, setSelectedExternalAppraiser] =
    useState<string>("");
  const [appraisalsDetailsRDX, setAppraisalDetailsRDX] =
    useState<AppraisalsDetailsModelForEquity>({
      currentAppraisalValue: 0,
      effectiveDateOfValue: "",
      sheduled_n_cost: 0,
      lastAppraisedValue: 0,
      lastAppraisalPercentageChange: 0,
      lastAppraisedDate: "",
      lastAnnualAppraisedValue: 0,
      lastAnnualAppraisalPercentageChange: 0,
      lastAnnualAppraisedDate: "",
      currencySelected: "",
      GPAppraisalValue:0
    });
  const [appraisalDetailsForCMRDX, setAppraisalDetailsForCMRDX] =
    useState<AppraisalDetailsModelForCM>({
      currencySelected: "",
      propertyValueAsIs: 0,
      propertyValueAsIsDate: "",
      capRateAsIs: 0,
      propertyValueStabilized: 0,
      propertyValueStabilizedDate: "",
      capRateStabilized: 0,
      propertyInsurableValue: 0,
      propertyLandValue: 0,
      reportDate: "",
    });
  const [appraisalDetailsForDLorDARDX, setAppraisalDetailsForDLorDARDX] =
    useState<AppraisalDetailsModelForDLorDA>({
      currencySelected: "",
      currentDebtValue: 0,
      currentPrincipalValue: 0,
      loanToValueRatio: 0,
      treasuryRate: 0,
      riskPremium: 0,
      surveyYield: 0,
      currentEffectiveDate: "",
      derivative: 0,
      lastDebtValue: 0,
      lastDebtPercentageChange: 0,
      lastDebtEffectiveDate: "",
    });

  const [externalAppraiserArray, setExternalAppraiserArray] = useState<
    string[]
  >([]);
  const [selectedAppraisalFirm, setSelectedAppraisalFirm] = useState<{
    label: string;
    value: string;
  }>({ label: "", value: "" });

  const [loading, setLoading] = useState<boolean>(false);
  const [isClaimed, setIsClaimed] = useState<boolean>(false);
    const [claimedBy, setClaimedBy] = useState<string>("");
  const [oldSelectedInvestment, setOldSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [newSelectedInvestment, setNewSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);

  const [firstLoadResults, setFirstLoadResults] = useState<{
    fundsUsersByUser: UserRoleMapModel[];
    allDocumentTypes: DocumentTypesModel[];
    allCountries: AllCountriesModel[];
    allExternalAppraisers: ExternalAppraisersModel[];
    appraisalData: GetAppraisalModel;
    auditData: AuditLog[];
  }>({
    fundsUsersByUser: [] as UserRoleMapModel[],
    allDocumentTypes: [] as DocumentTypesModel[],
    allCountries: [] as AllCountriesModel[],
    allExternalAppraisers: [] as ExternalAppraisersModel[],
    appraisalData: {} as GetAppraisalModel,
    auditData: [] as AuditLog[],
  });
  const [investmentIdAndType, setInvestmentIdAndType] = useState<{
    investmentId: string;
    investmentType: string;
  }>({ investmentId: "", investmentType: "" });
  const [flagtaskcomponent, setFlagtaskcomponent] = useState<boolean>(false);
  const [latestPendingAppraisal, setLatestPendingAppraisal] =
    useState<GetAppraisalModel>(new GetAppraisalModel());
  const [isPendingAppraisal, setIsPendingAppraisal] = useState<boolean>(false);
  const [allDocTypes, setAllDocTypes] = useState<DocumentTypesModel[]>([]);
  const [revokeComments, setRevokeComments] = useState("");
  // const [isMortgage, setIsMortgage] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  let isMortgage: boolean = false;
  const [appraisalFirms, setAppraisalFirms] = useState<
    { label: string; value: string }[]
  >([]);
  const [appraiser1List, setAppraiser1List] = useState<
    {
      firstName: string;
      lastName: string;
      email: string;
      name: string;
      userType: string;
    }[]
  >([]);
  const allCountries = React.useRef<AllCountriesModel[]>([]);
  const [selectedInvestment, setSelectedInvestment] =
    useState<InvestmentIDsModel | null>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [attachments, setAttachments] = useState<AppraisalAttachment[]>([]);
  const [modifiedAsset, setModifiedAsset] = useState<AppraisalAssetsModel[]>(
    []
  );
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [InvestmentIdAndAppraisalId, setInvestmentIdAndAppraisalId] = useState<{
    investmentId: string;
    appraisalId: string;
  }>({ investmentId: "", appraisalId: "" });
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );
  const [
    flagToDisableControlesForAppraisal,
    setFlagToDisableControlesForAppraisal,
  ] = useState<boolean>(false); //</boolean>: boolean = useAppSelector(state => state.UpdateFlagToDisableControlesForAppraisal.data);

  const appraisalDetails: AppraisalsDetailsModelForEquity = useAppSelector(
    (state) => state.AppraisalDetailsForUSAppraisal.data
  );
  const appraisalDetailsForCM: AppraisalDetailsModelForCM = useAppSelector(
    (state) => state.AppraisalDetailsForCM.data
  );

  const appraisalDetailsForDLorDA: AppraisalDetailsModelForDLorDA =
    useAppSelector((state) => state.AppraisalDetailsForDLorDA.data);

  const NewAttachmentList: AppraisalAttachment[] = useAppSelector(
    (state) => state.AddNewAttachments.data
  );

  const latestSelectedInvestment: InvestmentForAppraisalModel = useAppSelector(
    (state) => state.SelectedInvestmentForAppraisal.data
  );
  const modifiedAssets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  // const selectedInvestment = useAppSelector(
  //   (state) => state.SelectedInvestmentForAppraisal?.data
  // );
  const [cityStateCountry, setCityStateCountry] = useState<string>("");
  const [selectedAppraiser1, setSelectedAppraiser1] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    name: string;
    userType: string;
  } | null>({
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    userType: "",
  });

  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  
    const handleClickOpenClainBox = () => {
      setOpen(true);
    };
  
    const handleCloseClaimBox = () => {
      setOpen(false);
    };
  
    const handleClaim = async () => {
      setOpen(false);
      var appraisalObj = new AppraisalModel();
      appraisalObj.AppraisalId = firstLoadResults.appraisalData.appraisalId;
      appraisalObj.Xmin = firstLoadResults.appraisalData.xmin;
      appraisalObj.Status = firstLoadResults.appraisalData.status;
      appraisalObj.InvestmentId = firstLoadResults.appraisalData.investmentId;
      appraisalObj.AppraisalType = appraisalType;
      var appraiser1FirstName =
        selectedAppraiser1?.firstName != null
          ? selectedAppraiser1?.firstName
          : "";
      var appraiser1LastName =
        selectedAppraiser1?.lastName != null ? selectedAppraiser1?.lastName : "";
      var appraiser1email =
        selectedAppraiser1?.email != null ? selectedAppraiser1?.email : "";
      appraisalObj.Appraiser1 = {
        firstName: appraiser1FirstName,
        lastName: appraiser1LastName,
        email: appraiser1email,
      };
      appraisalObj.Appraiser2 = {
        firstName: "",
        lastName: "",
        email: "",
      };
      appraisalObj.Appraiser3 = {
        firstName: "",
        lastName: "",
        email: "",
      };
      appraisalObj.Fiduciary = {
        firstName: "",
        lastName: "",
        email: "",
      };
      appraisalObj.AppraiserFirm = selectedAppraisalFirm.label;
      appraisalObj.AssetManager = {
        ...firstLoadResults.appraisalData.assetManager,
      };
      appraisalObj.City = firstLoadResults.appraisalData.city;
      appraisalObj.State = firstLoadResults.appraisalData.state;
      appraisalObj.Country = firstLoadResults.appraisalData.country;
      appraisalObj.ExternalAppraiser = selectedAppraisalFirm.label;
      appraisalObj.Fund = firstLoadResults.appraisalData.fund;
      appraisalObj.FundId = firstLoadResults.appraisalData.fundId;
      appraisalObj.HasDebtLiability =
        firstLoadResults.appraisalData.hasDebtLiability;
      appraisalObj.InvestmentName = firstLoadResults.appraisalData.investmentName;
  
      appraisalObj.AssetManagerHead =
        firstLoadResults.appraisalData.assetManagerHead;
      appraisalObj.InvestmentPropertyType =
        firstLoadResults.appraisalData.investmentPropertyType;
      appraisalObj.InvestmentType = firstLoadResults.appraisalData.investmentType;
      appraisalObj.PortfolioManager =
        firstLoadResults.appraisalData.portfolioManager;
      appraisalObj.SectorHead = firstLoadResults.appraisalData.sectorHead;
      appraisalObj.CreatedBy = firstLoadResults.appraisalData.createdBy;
      appraisalObj.CanSubmit = true;
      appraisalObj.WorkflowId = firstLoadResults.appraisalData.workflowId;
      appraisalObj.WorkflowSteps = firstLoadResults.appraisalData.workflowSteps;
      appraisalObj.Created = firstLoadResults.appraisalData.created;
      appraisalObj.Stage = firstLoadResults.appraisalData.stage;
      var selectedInvType =
        firstLoadResults.appraisalData.investmentType.toLowerCase();
      if (selectedInvType === "equity") {
        appraisalObj.Currency = appraisalsDetailsRDX.currencySelected;
        appraisalObj.CurrentAppraisalValue =
          appraisalsDetailsRDX.currentAppraisalValue;
        appraisalObj.ValueDate = new Date(
          appraisalsDetailsRDX.effectiveDateOfValue
        );
        appraisalObj.ScheduleNCost = appraisalsDetailsRDX.sheduled_n_cost;
        appraisalObj.LastAppraisedValue = appraisalsDetailsRDX.lastAppraisedValue;
        appraisalObj.LastAppraisalDate = appraisalsDetailsRDX.lastAppraisedDate;
        appraisalObj.LastAnnualAppraisedValue =
          appraisalsDetailsRDX.lastAnnualAppraisedValue;
        appraisalObj.LastAnnualAppraisalDate =
          appraisalsDetailsRDX.lastAnnualAppraisedDate;
        appraisalObj.AnnualPercentageChange =
          appraisalsDetailsRDX.lastAnnualAppraisalPercentageChange;
        appraisalObj.PercentageChange =
          appraisalsDetailsRDX.lastAppraisalPercentageChange;
      }
  
      if (selectedInvType === "debt asset") {
        appraisalObj.Currency = appraisalDetailsForDLorDARDX.currencySelected;
        appraisalObj.CurrentAppraisalValue =
          appraisalDetailsForDLorDARDX.currentDebtValue;
        appraisalObj.currentPrincipalValue = appraisalDetailsForDLorDARDX.currentPrincipalValue;
        appraisalObj.loanToValueRatio = appraisalDetailsForDLorDARDX.loanToValueRatio != null ? Number(appraisalDetailsForDLorDARDX.loanToValueRatio?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.treasuryRate = appraisalDetailsForDLorDARDX.treasuryRate != null ? Number(appraisalDetailsForDLorDARDX.treasuryRate?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.riskPremium = appraisalDetailsForDLorDARDX.riskPremium != null ? Number(appraisalDetailsForDLorDARDX.riskPremium?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.surveyYield = appraisalDetailsForDLorDARDX.surveyYield != null ? Number(appraisalDetailsForDLorDARDX.surveyYield?.toString().replaceAll(",","")).toFixed(2) : null ;
        appraisalObj.ValueDate = new Date(
          appraisalDetailsForDLorDARDX.currentEffectiveDate
        );
        appraisalObj.Derivative = appraisalDetailsForDLorDARDX.derivative;
        appraisalObj.LastAppraisedValue =
          appraisalDetailsForDLorDARDX.lastDebtValue;
        appraisalObj.LastAppraisalDate =
          appraisalDetailsForDLorDARDX.lastDebtEffectiveDate;
        appraisalObj.PercentageChange =
          appraisalDetailsForDLorDA.lastDebtPercentageChange;
      }
  
      if (selectedInvType === "mortgage") {
        appraisalObj.Currency = appraisalDetailsForCMRDX.currencySelected;
        appraisalObj.PropertyValueAsIs =
          appraisalDetailsForCMRDX.propertyValueAsIs;
        appraisalObj.CapRateAsIs = appraisalDetailsForCMRDX.capRateAsIs;
        appraisalObj.PropertyValueAsIsDate =
          appraisalDetailsForCMRDX.propertyValueAsIsDate;
        appraisalObj.PropertyValueStabilized =
          appraisalDetailsForCMRDX.propertyValueStabilized;
        appraisalObj.PropertyValueStabilizedDate =
          appraisalDetailsForCMRDX.propertyValueStabilizedDate;
        appraisalObj.CapRateStabilized =
          appraisalDetailsForCMRDX.capRateStabilized;
        appraisalObj.PropertyInsurableValue =
          appraisalDetailsForCMRDX.propertyInsurableValue;
        appraisalObj.PropertyLandValue =
          appraisalDetailsForCMRDX.propertyLandValue;
        appraisalObj.ReportDate = appraisalDetailsForCMRDX.reportDate;
      }
  
      appraisalObj.Assets = modifiedAsset;
        appraisalObj.ClaimedBy = {
          firstName: userContext.firstName,
          lastName: userContext.lastName,
          email: userContext.email,
        };
  
        try {
          setLoading(true);
          await postApiCall(
            AppraisalReviewServiceURL + "/appraisals/" + "claim",
            appraisalObj,
            ServiceName.APPRAISALREVIEW
          ).then(async (data: any) => {
            setLoading(false);
            setIsSuccess({
              isSuccess: true,
              message: "Appraisal claimed successfully",
            });
            wait(3000).then(() => {
              setIsSuccess({ isSuccess: false, message: "" });
            });
          });
        } catch (error) {
          console.log(error);
        } finally {
          wait(3000).then(() => {
            setIsSuccess({ isSuccess: false, message: "" });
            //navigate("/main/appraisal-form/view/" + firstLoadResults.appraisalData.appraisalId);
            window.location.reload();
          });
        }
    };
  useEffect(() => {
    setModifiedAsset(modifiedAssets);
    console.log(modifiedAssets);
  }, [modifiedAssets]);

  useEffect(() => {
    setAttachments(NewAttachmentList);
    console.log(NewAttachmentList);
  }, [NewAttachmentList]);

  useEffect(() => {
    setAppraisalDetailsRDX(appraisalDetails);
  }, [appraisalDetails]);

  useEffect(() => {
    setAppraisalDetailsForCMRDX(appraisalDetailsForCM);
  }, [appraisalDetailsForCM]);

  useEffect(() => {
    setAppraisalDetailsForDLorDARDX(appraisalDetailsForDLorDA);
    console.log(appraisalDetailsForDLorDA);
  }, [appraisalDetailsForDLorDA]);

  // useEffect(() => {
  //   if (Object.keys(userContext).length == 0) {
  //     getProfile(true).then((data: any) => {
  //       dispatch(updateUserContext(data));
  //     });
  //   }
  // }, []);

  useEffect(() => {
      dispatch(updateAppraisalDetailsForUSAppraisal(new AppraisalsDetailsModelForEquity()));
        dispatch(updateAppraisalDetailsForCM(new AppraisalDetailsModelForCM()));
        dispatch(updateAppraisalDetailsForDLorDA(new AppraisalDetailsModelForDLorDA()));
        dispatch(updateAppraisalAssets([] as AppraisalAssetsModel[]));
      fetchAndPopulateData();
    
  }, [userContext]);

  console.log(appraisalDetails);
  console.log(appraisalDetailsForCM);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );

  useEffect(() => {
    setIsSubmit(submitEvent);
    if (submitEvent && firstLoadResults.appraisalData.assetManager != null) {
      if (
        firstLoadResults.appraisalData.assetManager.email.toLowerCase() ==
        "not.applicable@maskedqicaait.org"
      ) {
        setAssetManagerInvalid({
          flag: true,
          message: "Asset Manager Email is not Valid",
        });
      }
    }
  }, [submitEvent]);

  const fetchAndPopulateData = async () => {
    dispatch(addNewAttachments([] as AppraisalAttachment[]));
    dispatch(updateAttachments([] as AppraisalAttachment[]));
    try {
      setLoading(true);
      const [call2, call1, call3, call4, call5, call6, call7] =
        await Promise.all([
          getApiCall(
            AppraisalReviewServiceURL + "/appraisals/getbyid/" + appraisalId,
            ServiceName.APPRAISALREVIEW
          ).then((data: any) => {
            var d = data.result.appraisalType as string;
            if (!d.toLowerCase().includes("dl")) {
              navigate("/main/appraisal-form/" + page + "/" + appraisalId);
            }
            return data;
          }),
          getApiCall(
            TaskmgmtServiceURL +
              "/userrolemaps/GetFundsByUser?email=" +
              currentUserData.email?.toLowerCase(),
            ServiceName.TASKMANAGEMENTSERVICE
          ),
          getApiCall(
            LookupServieURL + "/DocumentTypes/GetAll",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            LookupServieURL + "/DocumentTypes/GetAllCountries",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            LookupServieURL + "/externalappraisers/getall",
            ServiceName.LOOKUPSERVICE
          ),
          getApiCall(
            TaskmgmtServiceURL + "/AuditTasks/GetByAppraisalId/" + appraisalId,
            ServiceName.TASKMANAGEMENTSERVICE
          ),
          getApiCall(
            DocumentServiceURL + "/Documents/getall/" + appraisalId,
            ServiceName.DOCUMENTSERVICE
          ),
        ]);

      const appraisalData: GetAppraisalModel = (call2 as any).result;
      if(appraisalData.claimedBy != null)
        {
          setIsClaimed(true);
          setClaimedBy(appraisalData.claimedBy.firstName + " " + appraisalData.claimedBy.lastName);
        }
      const loggs: AuditLog[] = [...(call6 as any).result];
      var formattedloggs: AuditLog[] = [];
      if (loggs.length != 0) {
        loggs.forEach((data: AuditLog) => {
          const date = new Date(data.created);
          const log: AuditLog = { ...data, created: date.toLocaleString() };
          formattedloggs.push(log);
        });
        
      }
      const startingLog:AuditLog = {
        id: "",
        appraisalId: "",
        status: "New",
        taskComments: "",
        approverName: "Created by "+appraisalData.createdBy,
        taskStatus: "",
        previousStatus: "",
        approverEmail: "",
        workflowId: "",
        xmin: 0,
        createdBy: "",
        created: appraisalData.created,
        lastModifiedBy: "",
        lastModified: ""
      }
      formattedloggs.push(startingLog);
      console.log("audit>>>>>>>",formattedloggs);
      dispatch(addAuditLogs(formattedloggs));


      var docArray: DocumentTypesModel[] = [...(call3 as any).result];
      const attcahments: AppraisalAttachment[] = [...(call7 as any)];
      var formattedAttachments: AppraisalAttachment[] = [];
      if (attcahments.length != 0) {
        attcahments.forEach((data: AppraisalAttachment) => {
          const date = new Date(data.lastModifiedDate);
          const doc: AppraisalAttachment = {
            ...data,
            lastModifiedDate: date.toLocaleString(),
          };
          formattedAttachments.push(doc);
        });
      }
      dispatch(updateAttachments(formattedAttachments));
      // docArray.push({id:0,
      //   name:"All",
      //   tag:"string",
      //   appraisalCycle:"string",
      //   investmentType:"string",
      //   sortOrder:0,
      //   region:"string"});
      const allDocTypes: DocumentTypesModel[] = docArray.sort(
        (a: any, b: any) => (a.id > b.id ? 1 : -1)
      );

      setFirstLoadResults({
        fundsUsersByUser: (call1 as any).result,
        appraisalData: appraisalData,
        allDocumentTypes: allDocTypes,
        allCountries: (call4 as any).result,
        allExternalAppraisers: (call5 as any).result,
        auditData: (call6 as any).result,
      });
      allCountries.current = (call4 as any).result;
      var allExternalAppraisers= (call5 as any).result;
      setInvestmentIdAndAppraisalId({
        investmentId: appraisalData.investmentId,
        appraisalId: appraisalData.appraisalId,
      });
      setAllDocTypes(allDocTypes);

      if (
        appraisalData.investmentType.toLowerCase() === "mortgage" ||
        appraisalData.investmentType.toLowerCase() === "equity"
      ) {
        var tempDocTypes: DocumentTypesModel[] = [...allDocTypes];
        setDocumentTypes(
          tempDocTypes.filter(
            (doc: DocumentTypesModel) => doc.name !== "Debt Record"
          )
        );
      } else {
        setDocumentTypes(allDocTypes);
      }

      let tempAppraiser1: {
        firstName: string;
        lastName: string;
        email: string;
        name: string;
        userType: string;
      }[] = [];
      let arrTempAppraiser1Email: string[] = [];
      const appFund: string = appraisalData.fundId;

      if (userContext.isAdmin) {
        (call1 as any).result.forEach((user: UserRoleMapModel) => {
          const email = user.email.toLowerCase();
          if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
            arrTempAppraiser1Email.push(email);
            tempAppraiser1.push({
              firstName: user.firstName,
              lastName: user.lastName,
              name: user.firstName + " " + user.lastName,
              email: email,
              userType: user.userType,
            });
          }
        });
      } else {
        (call1 as any).result.forEach((user: UserRoleMapModel) => {
          let arrCurrentFund = user.fundId.split(";");
          if (arrCurrentFund.indexOf(appFund) >= 0 && user.email) {
            const email = user.email.toLowerCase();
            if (user.email && arrTempAppraiser1Email.indexOf(email) == -1) {
              arrTempAppraiser1Email.push(email);
              tempAppraiser1.push({
                firstName: user.firstName,
                lastName: user.lastName,
                name: user.firstName + " " + user.lastName,
                email: email,
                userType: user.userType,
              });
            }
          }
        });
      }

      setAppraiser1List(
        tempAppraiser1
          .sort((a: any, b: any) => (a.firstName > b.firstName ? 1 : -1))
          .slice()
      );
      let currentUserIndex: number = tempAppraiser1.findIndex(
        (x) => x.email === userContext.email.toLowerCase()
      );

      if (appraisalData.appraiser1 != null) {
        var savedAppraiser1 =
          tempAppraiser1[
            tempAppraiser1.findIndex(
              (x) => x.email === appraisalData.appraiser1.email
            )
          ];
        if (savedAppraiser1 != undefined || savedAppraiser1 != null) {
          setSelectedAppraiser1(savedAppraiser1);
        } else {
          setSelectedAppraiser1(null);
        }
      } else {
        setSelectedAppraiser1(tempAppraiser1[currentUserIndex]);
      }

      if (appraisalData.appraiser1) {
        await getApiCall(
          TaskmgmtServiceURL +
            "/userrolemaps/getall/?isloader=0&$filter=(tolower(trim(email)) eq (tolower(trim('" +
            appraisalData.appraiser1.email +
            "'))))",
          ServiceName.TASKMANAGEMENTSERVICE
        ).then((data: any) => {
          console.log(data);
          if (data.result.length == 0) {
            setSelectedAppraiser1({
              firstName: appraisalData.appraiser1.firstName,
              lastName: appraisalData.appraiser1.lastName,
              email: appraisalData.appraiser1.email,
              name:
                appraisalData.appraiser1.firstName +
                " " +
                appraisalData.appraiser1.lastName,
              userType: "Internal",
            });
          } else {
            setSelectedAppraiser1({
              firstName: data.result[0].firstName,
              lastName: data.result[0].lastName,
              email: data.result[0].email,
              name: data.result[0].firstName + " " + data.result[0].lastName,
              userType: data.result[0].userType,
            });
          }
        });
      }
      if (appraisalData.status.search("Pending") != -1) {
        try {
          await getApiCall(
            TaskmgmtServiceURL +
            "/audittasks/GetOpenTask?isloader=0&&appraisalId=" +
            appraisalData.appraisalId +
            "&workflowId=" +
            appraisalData.workflowId +
            "&status=" +
            appraisalData.status,
            ServiceName.TASKMANAGEMENTSERVICE
          ).then((data: any) => {

            if (data.result.id) {

              var isUserAllowedToApproveByFund = false;
              if (userContext.isAdmin || userContext.isAppraisal2 || userContext.isAppraisal3 || userContext.isFiduciary || userContext.isDebtAppraisal2 || userContext.isDebtAppraisal3 || userContext.isDebtFiduciary) {
                isUserAllowedToApproveByFund = userContext.allowedFunds.filter((fund: any) => fund.fundId.includes(appraisalData.fundId)).length >= 1;
              }

              if (userContext.allowedFunds.filter((fund: any) => fund.fundId == "Any").length >= 1) {
                isUserAllowedToApproveByFund = true;
              }

              if (CheckCurrentStatusNReturnApprover(appraisalData))
                setFlagtaskcomponent(true && isUserAllowedToApproveByFund);
            }
          });
        } catch (e: any) {
          console.log("error in audittasks/GetOpenTask : ", e);
        }
      }

      //filtering the firms for firm autocomplete options
      let firmsArray: string[] = (call5 as any).result
        .map((d: ExternalAppraisersModel) => d.appraisalFirm)
        .filter(function (elem: any, index: any, self: string | any[]) {
          return index === self.indexOf(elem);
        })
        .filter((item: any) => item !== null);

      var tempFirmsArray: { label: string; value: string }[] = firmsArray
        .map((a) => {
          return { label: a, value: a };
        })
        .sort((a: any, b: any) => {
          if (b.value == null) return 1;
          return a.label > b.label ? 1 : -1;
        })
        .slice();

      setAppraisalFirms(tempFirmsArray);
      var firm: string = appraisalData.appraiserFirm;
      setSelectedAppraisalFirm({ label: firm, value: firm });

      var ExternalUsers: string[] = [];
      allExternalAppraisers.forEach(
        (appraiser: ExternalAppraisersModel) => {
          if (appraiser.appraisalFirm === firm) {
            ExternalUsers.push(appraiser.name);
          }
        }
      );
      populateDisplayForm(appraisalData, allDocTypes);
      const appraisalStatus: string = appraisalData.status.toLowerCase();
      const selectedInvestmentObj: InvestmentForAppraisalModel =
        new InvestmentForAppraisalModel();
      selectedInvestmentObj.investmentId = appraisalData.investmentId;
      selectedInvestmentObj.investmentType = appraisalData.investmentType;
      selectedInvestmentObj.name = appraisalData.investmentName;
      selectedInvestmentObj.fund = appraisalData.fund;
      selectedInvestmentObj.fundId = appraisalData.fundId;
      dispatch(updateSelectedInvestmentForAppraisal(selectedInvestmentObj));

      setExternalAppraiserArray([...ExternalUsers]);
      if (appraisalStatus === "new" || appraisalStatus.indexOf("reject") > -1) {
        fetchDataFromInvestment(appraisalData.investmentId, appraisalData);
      }
      if (
        appraisalStatus.toLowerCase() != "posted" &&
        appraisalStatus.toLowerCase() != "new" &&
        appraisalStatus.toLowerCase() != "revoked" &&
        appraisalStatus.toLowerCase().indexOf("rejected") == -1
      ) {
        setFlagToDisableControlesForAppraisal(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataFromInvestment = async (
    investmentId: string,
    appraisalData: GetAppraisalModel
  ) => {
    try {
      await getApiCall(
        InvestmentServiceURL +
          "/investments/GetByIdWithActiveAssets?id=" +
          investmentId,
        ServiceName.INVESTMENTSERVICE
      ).then((data: any) => {
        var investmentDetailsFromInvservice: InvestmentForAppraisalModel =
          data?.result;
        populateFieldBasedOnInvestment(
          investmentDetailsFromInvservice,
          appraisalData
        );
      });
    } catch (e) {
      console.log(e);
    }
  };

  const populateFieldBasedOnInvestment = (
    investmentDetailsFromInvservice: InvestmentForAppraisalModel,
    appraisalData: GetAppraisalModel
  ) => {
    console.log(investmentDetailsFromInvservice);
    var lastAppraisedValue =
      investmentDetailsFromInvservice.fgInvestmentAppraisalValues
        .lastDLAppraisedValue === null
        ? 0
        : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastDLAppraisedValue;

    let cityStateCountry: string = "";
    cityStateCountry =
      investmentDetailsFromInvservice.city != undefined &&
      investmentDetailsFromInvservice.city != ""
        ? investmentDetailsFromInvservice.city
        : cityStateCountry;

    cityStateCountry =
      investmentDetailsFromInvservice.state != undefined &&
      investmentDetailsFromInvservice.state != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.state
        : cityStateCountry;

    cityStateCountry =
      isMortgage &&
      investmentDetailsFromInvservice.country != undefined &&
      investmentDetailsFromInvservice.country != ""
        ? cityStateCountry + ", " + investmentDetailsFromInvservice.country
        : cityStateCountry;
    // this.fgAppraisalForm.get("isInvestmentHasDebtLiability").setValue(this.isNewDL ? false : objInvestment.hasDebtLiability);

    var lastDebtAppraisedDate =
    investmentDetailsFromInvservice.fgInvestmentAppraisalValues
      .lastAppraisalDate === "" ||
    investmentDetailsFromInvservice.fgInvestmentAppraisalValues
      .lastDLAppraisalDate == null
      ? ""
      : investmentDetailsFromInvservice.fgInvestmentAppraisalValues
          .lastDLAppraisalDate;

    dispatch(
      updateAppraisalDetailsForDLorDA({
        currencySelected: appraisalData.currency,
        currentDebtValue: appraisalData.currentAppraisalValue,
        currentPrincipalValue: appraisalData.currentPrincipalValue,
        loanToValueRatio: appraisalData.loanToValueRatio,
        treasuryRate: appraisalData.treasuryRate,
        riskPremium: appraisalData.riskPremium,
        surveyYield: appraisalData.surveyYield,
        currentEffectiveDate: appraisalData.valueDate,
        derivative: appraisalData.derivative,
        lastDebtValue:lastAppraisedValue,
        lastDebtPercentageChange:
          appraisalData.currentAppraisalValue != null &&
          investmentDetailsFromInvservice.fgInvestmentAppraisalValues
            .lastDLAppraisedValue !== null
            ? percentageChange(
                appraisalData.currentAppraisalValue,
                investmentDetailsFromInvservice.fgInvestmentAppraisalValues
                  .lastDLAppraisedValue
              )
            : 0,
        lastDebtEffectiveDate: lastDebtAppraisedDate,
      })
    );
  };

  const percentageChange = (curr: number, last: number) => {
    const change = (((curr - last) / last) * 100).toFixed(2);
    return change;
  };

  const formatNumberTo0Decimal = (num: any) => {
    const regxmain = /^-?\d+(\.\d+)?$/;
    const regex1 = /^\d+\.\d{1}$/;
    const regx2 = /^\d+$/;
    const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
    if (regxmain.test(num)) {
      return num.toFixed(2);
    }
    // if (regex1.test(num)) {
    //   return num.toFixed(2);
    // }else  if(regx2.test(num)) {
    //   return num.toFixed(2);
    // }else if(regx3.test(num)){
    //   return `${num.toFixed(2)}`;
    // }
    return num;
  }
  const populateDisplayForm = (
    appraisalData: GetAppraisalModel,
    allDocumentTypes: DocumentTypesModel[]
  ) => {
    if((appraisalData.workflowSteps != undefined || appraisalData.workflowSteps != null) && appraisalData.workflowSteps != ""){
      setWorkflowSteps(JSON.parse(appraisalData.workflowSteps));
      }else{
      setWorkflowSteps([] as string[]);
  }
    setActiveIndex(appraisalData.activeIndex);
    let cityStateCountry: string = "";
    cityStateCountry =
      appraisalData.city != undefined && appraisalData.city != ""
        ? appraisalData.city
        : cityStateCountry;

    cityStateCountry =
      appraisalData.state != undefined && appraisalData.state != ""
        ? cityStateCountry + ", " + appraisalData.state
        : cityStateCountry;

    cityStateCountry =
      isMortgage &&
      appraisalData.country != undefined &&
      appraisalData.country != ""
        ? cityStateCountry + ", " + appraisalData.country
        : cityStateCountry;
    setCityStateCountry(cityStateCountry);
    setAppraisalType(appraisalData.appraisalType);
    setSelectedExternalAppraiser(appraisalData.externalAppraiser);

    dispatch(
      updateAppraisalDetailsForDLorDA({
        currencySelected: appraisalData.currency,
        currentDebtValue: appraisalData.currentAppraisalValue,
        currentPrincipalValue: appraisalData.currentPrincipalValue,
        loanToValueRatio: appraisalData.loanToValueRatio,
        treasuryRate: appraisalData.treasuryRate,
        riskPremium: appraisalData.riskPremium,
        surveyYield: appraisalData.surveyYield,
        currentEffectiveDate: appraisalData.valueDate,
        derivative: appraisalData.derivative,
        lastDebtValue: appraisalData.lastAppraisedValue,
        lastDebtPercentageChange: formatNumberTo0Decimal(appraisalData.percentageChange),
        lastDebtEffectiveDate: appraisalData.lastAppraisalDate,
      })
    );
  };

  console.log(firstLoadResults.appraisalData);

  const CheckCurrentStatusNReturnApprover = (
    appraisalData: GetAppraisalModel
  ): boolean => {
    var val = false;
    switch (appraisalData.status.toLowerCase()) {
      case "pending appraiser 2 review": {
        val =
          ((userContext.isAppraisal2 || userContext.isDebtAppraisal2) &&
            (appraisalData.appraiser1.email !=
              userContext.email ||
              (appraisalData.appraiser2 == null
                ? false
                : appraisalData.appraiser2.email !=
                  userContext.email) ||
              (appraisalData.appraiser3 == null
                ? false
                : appraisalData.appraiser3.email !=
                  userContext.email) ||
              (appraisalData.fiduciary == null
                ? false
                : appraisalData.fiduciary.email !=
                  userContext.email))) ||
          userContext.isAdmin
            ? true
            : false;
        break;
      }
      case "pending appraiser 3 review": {
        val =
          ((userContext.isAppraisal3 || userContext.isDebtAppraisal3) &&
            ((appraisalData.appraiser1 == null
              ? false
              : appraisalData.appraiser1.email !=
                userContext.email) ||
              (appraisalData.appraiser2 == null
                ? false
                : appraisalData.appraiser2.email !=
                  userContext.email) ||
              (appraisalData.appraiser3 == null
                ? false
                : appraisalData.appraiser3.email !=
                  userContext.email) ||
              (appraisalData.fiduciary == null
                ? false
                : appraisalData.fiduciary.email !=
                  userContext.email))) ||
          userContext.isAdmin
            ? true
            : false;
        break;
      }
      case "pending fiduciary review": {
        val =
          ((userContext.isFiduciary || userContext.isDebtFiduciary) &&
            ((appraisalData.appraiser1 == null
              ? false
              : appraisalData.appraiser1.email !=
                userContext.email) ||
              (appraisalData.appraiser2 == null
                ? false
                : appraisalData.appraiser2.email !=
                  userContext.email) ||
              (appraisalData.appraiser3 == null
                ? false
                : appraisalData.appraiser3.email !=
                  userContext.email) ||
              (appraisalData.fiduciary == null
                ? false
                : appraisalData.fiduciary.email !=
                  userContext.email))) ||
          userContext.isAdmin
            ? true
            : false;
        break;
      }
      case "pending post fiduciary review": {
        val =
          ((userContext.isFiduciary || userContext.isDebtFiduciary) &&
            ((appraisalData.appraiser1 == null
              ? false
              : appraisalData.appraiser1.email !=
                userContext.email) ||
              (appraisalData.appraiser2 == null
                ? false
                : appraisalData.appraiser2.email !=
                  userContext.email) ||
              (appraisalData.appraiser3 == null
                ? false
                : appraisalData.appraiser3.email !=
                  userContext.email) ||
              (appraisalData.fiduciary == null
                ? false
                : appraisalData.fiduciary.email !=
                  userContext.email))) ||
          userContext.isAdmin
            ? true
            : false;
        break;
      }
    }
    return val;
  };

  const addDataToDB = async (btnEvent: string) => {
    var appraisalObj = new AppraisalModel();

    appraisalObj.AppraisalId = firstLoadResults.appraisalData.appraisalId;
    appraisalObj.Xmin = firstLoadResults.appraisalData.xmin;

    if (btnEvent == "save") {
      appraisalObj.Status = firstLoadResults.appraisalData.status;
      appraisalObj.AppraisalRejected =
        firstLoadResults.appraisalData.appraisalRejected;
    }
    if (btnEvent == "submit") {
      appraisalObj.Status = "Submit";
      appraisalObj.AppraisalRejected = false;
    }

    if (btnEvent == "delete") {
      appraisalObj.Status = firstLoadResults.appraisalData.status;
      appraisalObj.AppraisalRejected = false;
      appraisalObj.IsDeleted = true;
    }
    appraisalObj.InvestmentId = firstLoadResults.appraisalData.investmentId;
    appraisalObj.AppraisalType = appraisalType;
    var appraiser1FirstName =
      selectedAppraiser1?.firstName != null
        ? selectedAppraiser1?.firstName
        : "";
    var appraiser1LastName =
      selectedAppraiser1?.lastName != null ? selectedAppraiser1?.lastName : "";
    var appraiser1email =
      selectedAppraiser1?.email != null ? selectedAppraiser1?.email : "";
    appraisalObj.Appraiser1 = {
      firstName: appraiser1FirstName,
      lastName: appraiser1LastName,
      email: appraiser1email,
    };
    appraisalObj.Appraiser2 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Appraiser3 = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.Fiduciary = {
      firstName: "",
      lastName: "",
      email: "",
    };
    appraisalObj.AppraiserFirm = selectedAppraisalFirm.label;
    appraisalObj.AssetManager = {
      ...firstLoadResults.appraisalData.assetManager,
    };
    appraisalObj.City = firstLoadResults.appraisalData.city;
    appraisalObj.State = firstLoadResults.appraisalData.state;
    appraisalObj.Country = firstLoadResults.appraisalData.country;
    appraisalObj.ExternalAppraiser = selectedAppraisalFirm.label;
    appraisalObj.Fund = firstLoadResults.appraisalData.fund;
    appraisalObj.FundId = firstLoadResults.appraisalData.fundId;
    appraisalObj.HasDebtLiability =
      firstLoadResults.appraisalData.hasDebtLiability;
    appraisalObj.InvestmentName = firstLoadResults.appraisalData.investmentName;
    appraisalObj.WorkflowId = firstLoadResults.appraisalData.workflowId;
    appraisalObj.WorkflowSteps = firstLoadResults.appraisalData.workflowSteps;
    appraisalObj.AssetManagerHead =
      firstLoadResults.appraisalData.assetManagerHead;
    appraisalObj.InvestmentPropertyType =
      firstLoadResults.appraisalData.investmentPropertyType;
    appraisalObj.InvestmentType = firstLoadResults.appraisalData.investmentType;
    appraisalObj.PortfolioManager =
      firstLoadResults.appraisalData.portfolioManager;
    appraisalObj.SectorHead = firstLoadResults.appraisalData.sectorHead;
    appraisalObj.CreatedBy = firstLoadResults.appraisalData.createdBy;
    appraisalObj.CanSubmit = true;
    appraisalObj.Created = firstLoadResults.appraisalData.created;
    appraisalObj.Stage = firstLoadResults.appraisalData.stage;
    appraisalObj.Currency = appraisalDetailsForDLorDARDX.currencySelected;
    appraisalObj.CurrentAppraisalValue =
      appraisalDetailsForDLorDARDX.currentDebtValue;
      appraisalObj.currentPrincipalValue = appraisalDetailsForDLorDARDX.currentPrincipalValue;
      appraisalObj.loanToValueRatio = appraisalDetailsForDLorDARDX.loanToValueRatio != null ? Number(appraisalDetailsForDLorDARDX.loanToValueRatio?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.treasuryRate = appraisalDetailsForDLorDARDX.treasuryRate != null ? Number(appraisalDetailsForDLorDARDX.treasuryRate?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.riskPremium = appraisalDetailsForDLorDARDX.riskPremium != null ? Number(appraisalDetailsForDLorDARDX.riskPremium?.toString().replaceAll(",","")).toFixed(2) : null ;
      appraisalObj.surveyYield = appraisalDetailsForDLorDARDX.surveyYield != null ? Number(appraisalDetailsForDLorDARDX.surveyYield?.toString().replaceAll(",","")).toFixed(2) : null ;
    appraisalObj.ValueDate = new Date(
      appraisalDetailsForDLorDARDX.currentEffectiveDate
    );
    appraisalObj.Derivative = appraisalDetailsForDLorDARDX.derivative;
    appraisalObj.LastAppraisedValue =
      appraisalDetailsForDLorDARDX.lastDebtValue;
    appraisalObj.LastAppraisalDate =
      appraisalDetailsForDLorDARDX.lastDebtEffectiveDate;
    appraisalObj.PercentageChange =
      appraisalDetailsForDLorDA.lastDebtPercentageChange;

    try {
      setLoading(true);
      await postApiCall(
        AppraisalReviewServiceURL + "/appraisals/" + btnEvent,
        appraisalObj,
        ServiceName.APPRAISALREVIEW
      ).then(async (data: any) => {
        await getApiCall(
          InvestmentServiceURL +
            "/investments/updateinvestmentassets?InvestmentId=" +
            firstLoadResults.appraisalData.investmentId,
          ServiceName.INVESTMENTSERVICE
        ).then((data) => console.log(data));
        await terminateWorkflow(data.result);
        console.log(data.result);
      });
    } catch (error) {
      console.log(error);
    } finally {
      wait(1000).then(() => {
        setIsSuccess({ isSuccess: false, message: "" });
        navigate("/main/dashboard");
      });
    }
  };

  const terminateWorkflow = async (data: any) => {
    try {
      data.forEach(async (element: any) => {
        var deleteAppraisalTaskItem = new AppraisalTask();
        deleteAppraisalTaskItem.appraisalid = element.appraisalId;
        deleteAppraisalTaskItem.workflowId = element.workflowId;
        deleteAppraisalTaskItem.approver = userContext.displayName;
        deleteAppraisalTaskItem.firstname = userContext.firstName;
        deleteAppraisalTaskItem.lastname = userContext.lastName;
        deleteAppraisalTaskItem.approverEmail = userContext.email;
        deleteAppraisalTaskItem.comments = "";

        await postApiCall(
          TaskmgmtServiceURL + "/Workflows/Terminate",
          deleteAppraisalTaskItem,
          ServiceName.TASKMANAGEMENTSERVICE
        )
          .then((data: any) => {
            console.log(data);
          })
          .catch((e: any) => {
            console.log(e);
          });
      });
    } catch (e) {
    } finally {
      setIsSuccess({
        isSuccess: true,
        message: "Appraisal has been deleted",
      });
      wait(3000).then(() => {
        setIsSuccess({ isSuccess: false, message: "" });
      });
    }
  };

  const deleteAppraisal = () => {
    if (firstLoadResults.appraisalData.status.toLowerCase() != "posted") {
      addDataToDB("delete");
    }
  };

  const handleClose = () => {
    setOpenRevokeDialog(false);
  };

  const revokeappraisal = () => {
    if (revokeComments != "") {
      var revokeRequest = new AppraisalRevokedRequest();

      revokeRequest.Id = appraisalId != undefined ? appraisalId : "";
      revokeRequest.UerEmail = userContext.email;
      revokeRequest.Comments = revokeComments;

      try {
        postApiCall(
          AppraisalReviewServiceURL + "/appraisals/RevokeAppraisal",
          revokeRequest,
          ServiceName.APPRAISALREVIEW
        )
          .then((data: any) => {
            if (data.message === "POST Request successful.") {
              setIsSuccess({
                isSuccess: true,
                message: "Appraisal has been Revoked",
              });
              wait(3000).then(() => {
                setIsSuccess({ isSuccess: false, message: "" });
                navigate("/main/dashboard");
              });
            }
          })
          .catch((e: any) => {
            setIsError({
              isError: true,
              message: "Appraisal could not be revoked",
            });
            wait(3000).then(() => {
              setIsError({ isError: false, message: "" });
            });
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      setIsError({
        isError: true,
        message: "Please Add the comments for Appraisal to be Revoked",
      });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }
  };

  const getLastAppraisalByInvIdAndInvType = (lastAppraisalString: string) => {
    console.log(lastAppraisalString);

    const baseUrl = window.location.origin;
    console.log(baseUrl);
    if (
      InvestmentIdAndAppraisalId.investmentId == "" ||
      InvestmentIdAndAppraisalId.appraisalId == ""
    ) {
      if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Appraisal value for the selected investment does not exist",
        });
      if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
        setOpenModel({
          isOpen: true,
          message:
            "Last Annual Appraisal value for the selected investment does not exist",
        });
    } else {
      try {
        setLoading(true);
        var call:any = null;
        if (InvestmentIdAndAppraisalId.appraisalId == "") {
          call = getApiCall(
            AppraisalReviewServiceURL +
              "/appraisals/" +
              lastAppraisalString +
              "?inv=" +
              InvestmentIdAndAppraisalId.investmentId,
            ServiceName.APPRAISALREVIEW
          );
        } else {
          call = getApiCall(
            AppraisalReviewServiceURL +
              "/appraisals/" +
              lastAppraisalString +
              "?inv=" +
              InvestmentIdAndAppraisalId.investmentId +
              "&id=" +
              InvestmentIdAndAppraisalId.appraisalId,
            ServiceName.APPRAISALREVIEW
          );
        }
        if (call != null) {
          call
            .then((data: any) => {
              if (data.result.length > 0) {
                const id = data.result;
                const baseUrl = window.location.origin;
                const url = baseUrl + "/main/debt-liability/view/" + id;
                window.open(url, "_blank");
              } else {
                if (lastAppraisalString == "GetLastPostedAppraisalIdByInv")
                  setOpenModel({
                    isOpen: true,
                    message:
                      "Last Appraisal value for the selected investment does not exist",
                  });
                if (lastAppraisalString == "GetLastAnnualPostedAprslByInv")
                  setOpenModel({
                    isOpen: true,
                    message:
                      "Last Annual Appraisal value for the selected investment does not exist",
                  });
              }
            })
            .catch((e: any) => {
              console.log(e);
            })
            .finally(() => {
              setLoading(false);
            });
        }
      } catch (e: any) {
        console.log(e);
      }
    }
    // setOpenModel({isOpen:true,message:"Hello"});
  };

  return (
    <>
      <Modal
        open={openModel.isOpen}
        onClose={() => {
          setOpenModel({ isOpen: false, message: "" });
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <WarningIcon /> Notification
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {openModel.message}
          </Typography>
        </Box>
      </Modal>
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      {assetManagerInvalid.flag && (
        <ToastMessage message={assetManagerInvalid.message} severity="error" />
      )}
      <Dialog
        open={open}
        onClose={handleCloseClaimBox}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do you want to claim the Appraisal?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseClaimBox}>No</Button>
          <Button onClick={handleClaim} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openRevokeDialog} onClose={handleCloseClaimBox}>
        <DialogTitle>Enter Comments *</DialogTitle>
        <DialogContent>
          <TextareaAutosizee
            required
            value={revokeComments}
            autoFocus
            id="comment"
            aria-label="empty textarea"
            placeholder="Enter Comments Here..."
            minRows={7}
            onChange={(e: any) => setRevokeComments(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ textTransform: "none" }}
            onClick={revokeappraisal}
            color="primary"
          >
            Confirm
          </Button>
          <Button
            sx={{ textTransform: "none" }}
            onClick={handleClose}
            color="secondary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <div className="form-wrap">
        <Box sx={{ width: "100%", typography: "body1" }}>
          {loading && (
            <div className="overlaySpinner">
              <CircularProgress />
            </div>
          )}
          <Grid container spacing={3}>
            <Grid item xs></Grid>
            <Grid item xs={6}>
              <HorizontalStepper
                workflowSteps={workflowSteps}
                activeIndex={activeIndex}
              />
            </Grid>
            <Grid item xs></Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={4} sm={4}></Grid>
            <Grid sx={{ marginTop: "5px" }} item xs={4} sm={4}>
              {isClaimed && (
                <Alert
                  severity="info"
                  color="warning"
                  sx={{
                    justifyContent: "center",
                    marginBottom: 2,
                  }}
                >
                  {claimedBy + " is currently reviewing this appraisal"}
                </Alert>
              )}
            </Grid>
            <Grid item xs={4} sm={4} className="HamburgerActionButtons">
              {flagtaskcomponent && (
                <Button
                  sx={{ textTransform: "none", marginRight: 2 , backgroundColor :'#00AE98'}}
                  variant="contained"
                  size="medium"
                  onClick={() => handleClickOpenClainBox()}
                >
                  Claim
                </Button>
              )}
              <AuditButton />
              {/* <Grid container spacing={2}>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}>
                  <Grid container spacing={2}>
                    <Grid item xs={2} sm={2}></Grid>
                    <Grid item xs={2} sm={2}></Grid>
                    <Grid item xs={2} sm={3}>
                      <Button sx={{textTransform:"none"}}
                        variant="outlined"
                        size="medium"
                        style={{ marginTop: 20 }}
                        color="success"
                      >
                        Audit
                      </Button>
                    </Grid>
                    <Grid item xs={2} sm={2}> */}
              <HamburgerMenu
                appraisalId={appraisalId}
                loading={setLoading}
                userContext={userContext}
                workflowId={firstLoadResults.appraisalData.workflowId}
                deleteAppraisal={deleteAppraisal}
                isSuccess={setIsSuccess}
                isError={setIsError}
              />
              {/* </Grid>
                  </Grid>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6}>
              <h3 className="heading">Appraisal Type : {appraisalType}</h3>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}></Grid>
                <Grid item xs={3} sm={4}>
                  {firstLoadResults.appraisalData.hasDebtLiability && (
                    <Alert
                      severity="info"
                      sx={{
                        justifyContent: "center",
                        marginBottom: 2,
                        padding: 0,
                      }}
                    >
                      {"Debt Liability Associated"}
                    </Alert>
                  )}{" "}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                label="Investment"
                value={
                  firstLoadResults.appraisalData.investmentId +
                  " - " +
                  firstLoadResults.appraisalData.investmentName
                }
                variant="outlined"
                size="small"
                fullWidth
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                label="Fund"
                value={
                  firstLoadResults.appraisalData.fundId +
                  " : " +
                  firstLoadResults.appraisalData.fund
                }
                variant="outlined"
                size="small"
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                InputProps={{
                  readOnly: true,
                }}
                label="Asset Manager"
                value={
                  firstLoadResults.appraisalData.assetManager != null
                    ? firstLoadResults.appraisalData.assetManager?.firstName +
                      ", " +
                      firstLoadResults.appraisalData.assetManager?.lastName
                    : ""
                }
                variant="outlined"
                size="small"
                error={
                  isSubmit &&
                  firstLoadResults.appraisalData.assetManager === null
                }
                fullWidth
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                required
                InputLabelProps={{
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                label="City/State/Country"
                value={cityStateCountry}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: true,
                }}
                label={
                  "Appraiser 1" +
                  `{ ${
                    selectedAppraiser1?.userType != undefined
                      ? selectedAppraiser1?.userType
                      : ""
                  }  User }`
                }
                value={
                  selectedAppraiser1?.firstName +
                  ", " +
                  selectedAppraiser1?.lastName
                }
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                required
                label="Investment Type"
                value={firstLoadResults.appraisalData?.investmentType}
                variant="outlined"
                fullWidth
                size="small"
                className="Autopopulatefield"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                required
                label="Appraisal Firm"
                value={selectedAppraisalFirm.label}
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField
                InputProps={{
                  readOnly: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    "& .MuiInputLabel-asterisk": {
                      color: "red",
                    },
                  },
                }}
                required
                label="External Appraiser"
                value={selectedExternalAppraiser}
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
        </Box>
        <Divider className="divider-line"></Divider>
        <Box
          sx={{ width: "100%", typography: "body1" }}
          className="accordion-wrap"
        >
          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <Typography>Appraisal Value</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <AppraisalValueTableForDLorDA
                flagToDisableControlesForAppraisal={
                  flagToDisableControlesForAppraisal
                }
                openLastAppraisalValue={getLastAppraisalByInvIdAndInvType}
                view={true}
                countriesData={allCountries.current}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls="panel3d-content"
              id="panel3d-header"
            >
              <Typography>Documents</Typography>
            </AccordionSummary>
            <AccordionDetails className="upload-document">
              {documentTypes.length != 0 && (
                <ViewTabList
                  tabData={documentTypes}
                  appraisalType={appraisalType}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box sx={{ padding: "15px 2px" }}>
          <Grid item xs={12}>
            <Button
              sx={{ textTransform: "none", ml: 2 }}
              variant="outlined"
              size="medium"
              onClick={() => navigate("/main/dashboard")}
              color="error"
            >
              Close
            </Button>
            <Button
              sx={{ textTransform: "none", ml: 2 }}
              variant="contained"
              size="medium"
              color="success"
              disabled={
                !(
                  (userContext.isAppraisal1 ||
                    userContext.isDebtAppraisal1 ||
                    userContext.isAdmin) &&
                  (firstLoadResults.appraisalData.status === "New" ||
                    firstLoadResults.appraisalData.status ===
                      "Pending for Appraiser 1 Review" ||
                    firstLoadResults.appraisalData.appraisalRejected ||
                    firstLoadResults.appraisalData.status === "Revoked")
                )
              }
              onClick={() =>
                navigate(
                  "/main/appraisal-form/edit/" +
                    firstLoadResults.appraisalData.appraisalId
                )
              }
            >
              Edit
            </Button>
            {flagtaskcomponent && (
              <ApproveRejectComponent
                isError={setIsError}
                isSuccess={setIsSuccess}
                userContext={userContext}
                status={firstLoadResults.appraisalData.status}
                appraisalId={firstLoadResults.appraisalData.appraisalId}
                workflowId={firstLoadResults.appraisalData.workflowId}
              />
            )}
          </Grid>
        </Box>
      </div>
    </>
  );
};
